import {Component, effect, inject, input} from '@angular/core'
import {BaseTable, ConfirmComponent, WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {MatSort, MatSortHeader} from '@angular/material/sort'
import {DataService} from '../../../services/data-service'
import {RouterLink} from '@angular/router'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {DatePipe} from '@angular/common'
import {MatDialog, MatDialogRef} from '@angular/material/dialog'
import {filter, switchMap} from 'rxjs'
import {MatPaginator} from '@angular/material/paginator'
import {ApprovalStatusMarker} from '../../approval-status-marker/approval-status-marker.component'

export interface IFlatItem {
  id: string
  sub: string
  subs: string[]
  names: string[]
  name: string
  office: string
  advisor: string
  date: number
  status: string
  // The step to navigate to on click
  step: number
}

@Component({
  selector: 'spb-list',
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatSort,
    MatSortHeader,
    MatTable,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatHeaderCellDef,
    RouterLink,
    MatIconButton,
    MatIcon,
    DatePipe,
    MatPaginator,
    ApprovalStatusMarker
  ],
  templateUrl: './list.html',
  styleUrl: './list.scss'
})
export class List extends BaseTable<IFlatItem> {

  public source = input.required<IFlatItem[]>()

  private readonly service = inject(DataService)

  private readonly dialog = inject(MatDialog)

  constructor() {
    super()
    this.columns.set(['date', 'name', 'advisor','office', 'status', 'delete'])
    effect(() => {
      this.items.data = this.source()
    })
  }

  public delete(id: string) {
    let ref: MatDialogRef<any>
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Bekräfta',
        text: 'Är du säker på att du vill ta bort kalkylen?'
      }
    }).afterClosed()
      .pipe(
        filter(Boolean),
        switchMap(() => {
          ref = this.dialog.open(WaitComponent, {data: {title: 'Vänta', text: 'Tar bort...'}})
          return this.service.delete(id)
        })
      )
      .subscribe(() => {
        ref.close()
      })
  }
}
